import React from "react"
import {ThemeContext} from "./ThemeContext"
import {Link} from "react-router-dom";

const Navbar = () =>{
    const { toggle } = React.useContext(ThemeContext);
  return(
        <div style={toggle ? {backgroundColor: "#F0EEF0"} : {backgroundColor: "black"}}>
        <nav className="custom-nav">
            <ul>
                <li >
                    <Link to="/" style={toggle ? {color: "black"} : {color: "white"}}>Home</Link>
                </li>
                <li>
                    <Link to="/crud-hooks" style={toggle ? {color: "black"} : {color: "white"}}>CRUD Hooks</Link>
                </li>
                <li>
                    <Link to="/axios" style={toggle ? {color: "black"} : {color: "white"}}>Axios</Link>
                </li>
                <li>
                    <Link to="/context" style={toggle ? {color: "black"} : {color: "white"}}>Context</Link>
                </li>
                <li>
                    <Link to="/nilai-mahasiswa" style={toggle ? {color: "black"} : {color: "white"}}>Nilai Mahasiswa</Link>
                </li>
                <li>
                    <Link to="/switch-theme" style={toggle ? {color: "black"} : {color: "white"}}>Switch Theme</Link>
                </li>
            </ul>
        </nav>
        </div>
  )
}

export default Navbar